import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./theme";
import { AuthProvider } from "./contexts/AuthContext";
import { LiffProvider } from "./contexts/LiffContext";
import { LineBranchProvider } from "./contexts/LineBranchContext";
import { useEffect } from "react";
import "./App.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./utils/helper";
import { BRAND_UI } from "@/constants";

function App() {
  const mode = import.meta.env.VITE_MODE;

  useEffect(() => {
    document.title = BRAND_UI.brand.siteTitle;
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <LiffProvider mode={mode}>
        <AuthProvider>
          <ThemeProvider theme={theme}>
            <LineBranchProvider>
              <Router>
                <AppRoutes />
              </Router>
            </LineBranchProvider>
          </ThemeProvider>
        </AuthProvider>
      </LiffProvider>
    </QueryClientProvider>
  );
}

export default App;
